import { render } from "./HomePhotography.vue?vue&type=template&id=32dfbc8d"
import script from "./HomePhotography.vue?vue&type=script&lang=js"
export * from "./HomePhotography.vue?vue&type=script&lang=js"

import "./HomePhotography.vue?vue&type=style&index=0&id=32dfbc8d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__